<template>
  <div class="adm-content-item" v-if="value">
    <h5 class="adm-content-item__title">
      <a :href="value.url" target="_blank" rel="noopener noreferrer">
        <span style="color: #3c3c3c">{{ !!value.title ? value.title : "" }}</span>
        <span class="adm-content-item__type" title="在新窗口打开">
          <iv-icon type="md-open" size="16" />
        </span>
      </a>
      <span style="font-weight: normal; mergin-left: 50px">（发布于{{ value.postTime | timesify }}）</span>

      <span class="item_edit" @click="editVal" v-rbac-allow="['publicSentiment', 'edit']"><iv-icon type="ios-compose-outline" size="16" style="vertical-align: text-bottom" />修改标题</span>
      <span class="adm-content-item__read pull-right" v-if="is_confirm == 1">已收录</span>
      <span class="adm-content-item__exclude pull-right" v-if="is_confirm == 2">已排除</span>
    </h5>
    <div class="adm-content-item__detail">
      <div class="adm-content-item__meta">
        <div>公司名称：{{ value.companyInfo.abbreviation }}</div>
        <div>数据来源：{{ value.source }}</div>
      </div>
      <div class="adm-content-item__meta">
        <div>关键词： {{ value.keywords }}</div>
        <iv-poptip trigger="hover" title="命中内容：" width="650" placement="top-start">
          <div class="item_section">命中内容：<span v-html="HightLight"></span></div>
          <div slot="content" style="white-space: normal; word-break: break-all"><span v-html="HightLight"></span></div>
        </iv-poptip>
      </div>
      <slot />
      <div class="adm-content-item__meta">
        <div><iv-button v-rbac-allow="['publicSentiment', 'edit']" size="small" type="primary" :ghost="is_confirm == '1'" @click="clickHandle('1')">收录</iv-button></div>
        <div><iv-button v-rbac-allow="['publicSentiment', 'edit']" size="small" type="primary" ghost @click="clickHandle('2')">排除</iv-button></div>
      </div>
    </div>
    <iv-modal :mask-closable="false" title="修改标题" width="450" :closable="false" v-model="EditTitle" @on-cancel="EditTitle = false">
      <iv-form :model="formValidate" :rules="ruleValidate" ref="formValidate" label-position="top" inline>
        <iv-form-item label="标题" prop="title">
          <iv-input type="text" v-model="formValidate.title" placeholder="请输入标题" style="width: 400px"></iv-input>
        </iv-form-item>
      </iv-form>
      <iv-button type="text" size="large" slot="footer" @click="EditTitle = false">取消</iv-button>
      <iv-button type="primary" size="large" slot="footer" @click="update">确定</iv-button>
    </iv-modal>
  </div>
</template>
<style lang="scss" scoped>
.adm-content-item {
  // padding: 10px 0;
  color: #999999;
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    padding: 5px 10px 0 10px;
    small {
      color: #aaa;
      font-weight: normal;
      margin-left: 0.625em;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__detail {
    display: flex;
    justify-content: space-between;
  }
  &__meta {
    padding: 0 10px;
    flex-grow: 1;
    &:nth-child(1) {
      width: 120px;
      position: relative;
      &::after {
        content: "";
        height: 50px;
        width: 1px;
        border-right: 1px solid #dddddd;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    &:nth-child(2) {
      width: 350px;
      position: relative;
      &::after {
        content: "";
        height: 50px;
        width: 1px;
        border-right: 1px solid #dddddd;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    &:nth-child(3) {
      width: 360px;
      padding-right: 0;
      flex-grow: 0;
    }
    &:nth-child(4) {
      width: 60px;
      flex-grow: 0;
    }
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      display: block;
    }
    .negative > .ivu-select >>> .ivu-select-selection {
      background: #ed4c4c;
    }
    .positive > .ivu-select >>> .ivu-select-selection {
      background: #33ab15;
    }
    .item_section {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 2; //显示的行
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }
  &__buttons {
    opacity: 1;
    transition: opacity 0.5s ease-out;
    a,
    button {
      margin-left: 0.625em;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &__type {
    vertical-align: middle;
    margin-left: 7px;
  }
  &__read {
    color: #2d8cf0;
  }
  &__exclude {
    color: #ed4c4c;
  }
}
</style>
<script>
const options = {
  sentiment_list: [
    { id: "负面", title: "负面" },
    { id: "正面", title: "正面" },
  ],
};
export default {
  props: {
    value: Object,
    type: {
      type: String,
      default: "draft",
    },
    is_confirm: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: {
        ...options,
      },
      EditTitle: false,
      formValidate: { title: "" },
      ruleValidate: {
        title: [{ type: "string", required: true, message: "请输入标题", trigger: "change" }],
      },
    };
  },
  methods: {
    find(arr, val, field = "id") {
      return arr.find((item) => item[field] == val) || {};
    },
    clickHandle(val) {
      this.$emit("confirm", { id: this.value.id, is_confirm: val });
    },
    async update() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$emit("title", { id: this.value.id, title: this.formValidate.title });
          this.$$success(`标题成功修改为${this.formValidate.title}`);
          this.EditTitle = false;
        }
      });
    },
    editVal() {
      this.EditTitle = true;
      this.formValidate.title = this.value.title;
    },
  },
  computed: {
    HightLight() {
      var status = 0;
      var text = this.value.negativeSection;
      switch (this.value.keywords) {
        case "无":
          break;

        default:
          var arr = this.value.keywords.split(";");
          arr.forEach((item) => {
            if (!item.trim()) return "";
            let replaceReg = new RegExp(item, "g");
            let replaceString = '<span class="search-text">' + item + "</span>";
            text = text.replace(replaceReg, replaceString);
          });
          break;
      }
      return text;
    },
  },
};
</script>
